module.exports = __webpack_public_path__ + "img/94836.3ebfb992.svg";